<template >
    <div class="container-fluid" v-if="lesson">


       <div class="row">
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h2>{{lesson.name}}</h2>
          </div>
          <div class="card-body">
            <p>{{lesson.description}}</p>
            <div class="btn btn-info btn-sm">
              <router-link :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}" class="text-white">Хичээлийн мэдээлэл засах</router-link>
            </div>
            <div class="btn btn-default  btn-sm mx-1 my-2">
              <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}">Хичээлийн зураг оруулах</router-link>
            </div>
            <br/>

            <br/>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary btn-sm" type="button" v-for="type in lesson.types">
                  {{type}}

                </button>

              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h2>Мэдээлэл</h2>
          </div>
          <div class="card-body">
            <p>Багш: {{lesson.profession}}</p>
            <p>Xичээлийн код: {{lesson.lectureCode}}, {{lesson.id}}</p>
            <p v-if="lesson.semester">Улирал: {{lesson.semester.id}}</p>
            <p v-if="lesson.credit">Кредит: {{lesson.credit}}</p>
            <p v-if="lesson.school">Сургууль: {{lesson.school.id}}</p>
            <p v-if="lesson.department">Xөтөлбөрийн баг: {{lesson.department.id}}</p>
            <p v-if="lesson.program">Хөтөлбөр: {{lesson.program.id}}</p>
          </div>
        </div>
      </div>

    </div>

   <hr class="mb-5"/>
      

      <div class="card shadow mb-4">
          
        <div class="card-header py-3">
          <div class="row">
            <div class='col'>
              <h3>Оюутнууд</h3>
            </div>
            <div class="col-auto">
              <button class="btn btn-success btn-sm" @click="$router.push({ name: 'LessonAttendance', params: { lessonId: lessonId} })" >Ирцийн мэдээлэл</button>
            </div>
          </div>
        </div>
        <div class="card-body">
            <form class="user">
              <div>
                "<span  style="color:red">Оюутны код</span> &nbsp;&nbsp;<span style="color:blue">Регистр</span>" форматаар оруулна уу!!!.  Жишээ нь:
                <br/>
                D123456 УХ0000000<br/>
                D123457 БА99999999
                <br/>
                <div class="text-danger">Та дээрх форматнаас зөрүүлж оруулсан тохиолдолд оюутан нэвтэрч чадахгүй болно!!!</div>
              </div>
              <div class="form-group">
                <textarea rows="10" v-model.trim="studentsText" class="form-control" placeholder="Оюутнуудын мэдээлэл"/>
              </div>
           
              <button type="button" class="btn btn-primary" @click="addStudents">
                Оюутан нэмэх
              </button>
              <hr>
              
            </form>
            <h3>Нэмэгдсэн оюутнууд</h3>
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="students!=null && students.length>0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Овог/Нэр</th>
                  <th>Оюутны дугаар</th>
                  <th>Регистр</th>
                  <th>Төлөв</th>
                  <th>Үйлдэл</th>

                </tr>
              </thead>

              <tbody>
                <tr v-for="(std, index) in students" v-bind:key="std.id">
                  <td>{{index+1}}</td>
                  <td><span v-if="std.student!=null">{{std.student.lastname}}/{{std.student.name}}</span></td>

                  <td><span v-if="std.student!=null">{{std.student.code}}</span></td>
                  <td><span v-if="std.student!=null">{{std.student.register}}</span></td>
                  <td>
                    <span v-if="std.enabled==true" class="badge badge-pill badge-success">идэвхтэй</span>
                    <span v-else class="badge badge-pill badge-danger">блоклосон</span>
                  </td>
                  <td>

                    <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                    <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button>
                    <button v-else class='btn btn-sm btn-primary mx-1' @click="setEnabledForStudent(std, true)">эрх нээх</button>
                  </td>
                </tr>
                
              </tbody>
            </table>
            <div v-else class="alert alert-info text-center">
                Одоогоор энэ хичээлийг үзэж байгаа оюутан байхгүй байна.
            </div>
        </div>

      </div>

      <div class="modal fade bd-example-modal-lg" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
        <div class="modal-dialog  modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Оюутан нэмэх</h5>
        
            </div>
            <div class="modal-body">
                <div class="table-responsive" v-if="tmpStudents!=null && tmpStudents.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Оюутны код</th>
                        <th>Регистр</th>

                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(student, index) in tmpStudents" >
                            <td>{{index+1}}</td>
                            <td>
                              <input type="text" v-model="student.code"/>
                            </td>
                   
                            <td>
                              <input type="text" v-model="student.register"/>
                            </td>
             
                            <td>
                                <button class="btn btn-success btn-sm" @click="checkStudentAdd(student, index)">Нэмэх</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
           
                </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'


export default {
    name: "LessonDetail",

    data() {
        return {
            lesson: null,

            types:[],
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
            students:[],

            lessonBucket:'lessonFiles/',
            topicBucket:'lessonTopicFiles/'
            
        };
    },
    methods: {
        
      _getQA(){

          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data()
              lesson.id=doc.id
              this.lesson=lesson;
            
          });

          fb.db.collection("lessons/"+this.lessonId+'/studentList').onSnapshot(querySnapshot=> {
              this.students=[]
              querySnapshot.forEach(stddata=> {
                let object=stddata.data()
                object.id = stddata.id;
                object.student=null;
                object.ref=stddata.ref;
                if(stddata.data().studentRef!=null){
                  stddata.data().studentRef.get().then(studentDoc=>{
                    object.student=studentDoc.data();

                  });
                }
                this.students.push(object);
              });
            
          });

   

      },

     
      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { lessonId: this.lessonId, type: type.id, topicId: topic.id} })
      },
      addStudents(){
        if(this.studentsText!=null && this.studentsText!=''){

          var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
          this.tmpStudents=[];
          if(arrayOfLines!=null && arrayOfLines.length>0){
            arrayOfLines.forEach(value=>{
              // console.log(value);
              var lineArray=value.split(/\s+/);
              console.log(lineArray);
              if(lineArray!=null && lineArray.length==2 && lineArray[0]!=null && lineArray[0]!='' && lineArray[1]!=null && lineArray[1]!=''){
                // var lessonRef= fb.db.collection("lessons").doc(this.lessonId);
                // var studentRef=fb.db.collection("students").doc(lineArray[0].toLowerCase()).get().then(studentData=>{
                  var studentDetail={};

                //   if(studentData!=null && studentData.exists){
                //     studentDetail.id=studentData.id;
                //     studentDetail.code=studentData.data().code;
                //     studentDetail.register=studentData.data().register;
                //     studentDetail.name=studentData.data().name;
                //     studentDetail.lastname=studentData.data().lastname;
                //     studentDetail.allowed=true;
                //     this.tmpStudents.push(studentDetail);
                //     // studentDetail=studentData.data();
                //     // this.addStudentToLesson(lessonRef, studentData, studentDetail);
                //   }
                //   else{
                    // fb.db.collection("students").where("register", "==", lineArray[1].toLowerCase()).get().then(value=>{
                    //   if(value.empty)
                    //   {
                    var allowed=false;
                    if(lineArray[0].toLowerCase().startsWith("d")==true && lineArray[1].length>=6)
                      allowed=true;
                    // if(lineArray[0].length>0 && lineArray[1].length>=6)
                    //   allowed=true;
            
                    studentDetail={
                      'code':lineArray[0].toLowerCase(),
                      'register': lineArray[1].toLowerCase(),
                      // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef),
                      'id':null,
                      'allowed':allowed
                    };
                    this.tmpStudents.push(studentDetail);
                    //     studentData.ref.set(
                    //       studentDetail
                    //     );
                    //     this.addStudentToLesson(lessonRef, studentData, studentDetail);
                    //   }
                    // });
                
                  // }
                  
                // });

              }
            });
            this.studentsText='';
            $('.bd-example-modal-lg').modal('show');
          }
        }
      },
      async checkStudentAdd(std, index){
        if(std!=null && std.code!=null && std.register!=null){
          // if(std.code.length<1){
          if(std.code.startsWith("d")==false){
            alert("Оюутны код буруу форматтай байна.Засна уу? d0123456 форматтай байх.");
            return;
          }
          if(std.register.length<6){
            alert("Оюутны регистрийн дугаар буруу байна .");
            return;
          }
          var lessonRef= fb.db.collection("lessons").doc(this.lessonId);
          var stdExists=await fb.db.collection("students").where("code", '==', std.code).where("register", "==", std.register).limit(1).get();
          if(!stdExists.empty){
            std.allowed=true;
            this.addStudentToLesson(lessonRef, stdExists.docs[0], std);
            this.tmpStudents.splice(index, 1);
            this.checkModalShow();
          }
          else{

            var stdCheckByCode=await fb.db.collection("students").doc(std.code).get();
            if(stdCheckByCode.exists){
              var r = confirm(std.code+" кодтой оюутаны регистрийн дугаар зөрж байна.Бүртгэгдсэн регистрийн дугаар "+ stdCheckByCode.data().register+", нэр "+stdCheckByCode.data().name+" байна.ТА энэ оюутныг хичээл дээр нэмэх үү?");
              if (r == true) {
                this.addStudentToLesson(lessonRef,  stdCheckByCode, std);
                this.tmpStudents.splice(index, 1);
                this.checkModalShow();
              } 
              return;
            }

            var stdCheckByRegister=await fb.db.collection("students").where("register", "==", std.register).limit(1).get();
            if(!stdCheckByRegister.empty){
              var r = confirm(std.register+" регистертэй оюутаны код зөрж байна.Бүртгэгдсэн оюутны код "+ stdCheckByRegister.docs[0].data().code+", нэр "+stdCheckByRegister.docs[0].data().name+" байна.ТА энэ оюутныг хичээл дээр нэмэх үү?");
              if (r == true) {
                this.addStudentToLesson(lessonRef,  stdCheckByRegister.docs[0], std);
                 this.tmpStudents.splice(index, 1);
                 this.checkModalShow();
              } 
              return;
            }


           
            std.allowed=true;
            var newStdRef=fb.db.collection("students").doc(std.code);
            newStdRef.set({"code": std.code, 'register':std.register, "createdAt": new Date(), "created": fb.db.collection("users").doc(this.$store.getters.currentUser.uid)});
            var stdData=await newStdRef.get();
            this.addStudentToLesson(lessonRef, stdData, std);
            this.tmpStudents.splice(index, 1);
            this.checkModalShow();
            
          }
        }
        else{
          alert("Оюутны мэдээлэл дутуу байна.");
        }
      },
      checkModalShow(){
        if(this.tmpStudents.length==0)
          $('.bd-example-modal-lg').modal('hide');
      },
      addStudentToLesson(lessonRef, studentData, studentDetail){
        studentData.ref.collection("lessonList").doc(lessonRef.id).get().then(stLesson=>{
          if(stLesson!=null && stLesson.exists){

          }
          else{
            studentData.ref.collection("lessonList").doc(lessonRef.id).set({
              lessonRef: lessonRef,
              addedDate: new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
        
        lessonRef.collection("studentList").doc(studentData.id).get().then(lessonSt=>{
          if(lessonSt!=null && lessonSt.exists){

          }
          else{
            lessonRef.update({
              'numberOfStudents': fb.firestore.FieldValue.increment(1)
            });
            lessonRef.collection("studentList").doc(studentData.id).set({
              addedDate:new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              studentRef: studentData.ref,
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
      },
 
   
      setEnabledForStudent(stddata, value){
        this.setProperty("enabled", stddata.ref, value);
        this.setProperty("enabled", fb.db.doc("students/"+stddata.id+"/lessonList/"+this.lessonId), value);
        
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      removeStudent(stddata){
        fb.db.doc("students/"+stddata.id+"/lessonList/"+this.lessonId).delete();
        stddata.ref.delete();
        fb.db.collection("lessons").doc(this.lessonId).update({
          'numberOfStudents': fb.firestore.FieldValue.increment(-1)
        });

      },
      setPublished(value, lesson){
        this.setProperty("published", fb.db.doc("lessons/"+lesson.id), value);
        if(value==true){
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
        }
        else{
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
        }
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

